import React, { createContext, useState, useContext } from "react";
import {
  Snackbar,
  Slide,
} from '@material-ui/core'
const WSnackbarContext = createContext();

export function useWSnackbar() {
  return useContext(WSnackbarContext);
}

export const WSnackbarConsumer = WSnackbarContext.Consumer;

export function WSnackbarProvider({ children }) {

  const [messageInfo, setMessageInfo] = useState({
    show: false,
    message: '警示訊息',
    autoHideDuration: null,
  })

  const show = (options) => {
    setMessageInfo(state => ({
      ...state,
      autoHideDuration: 3000,
      ...options,
      show: true }))
  }

  const hide = () => {
    setMessageInfo(state => ({...state, show:false}))
  }

  const value = { messageInfo, setMessageInfo, show, hide};
  return (
    <WSnackbarContext.Provider value={value}>
      {children}
      <Snackbar
        open={messageInfo.show}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={hide}
        TransitionComponent={Slide}
        autoHideDuration={messageInfo.autoHideDuration}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={<span id="message-id">{messageInfo.message}</span>}
      />
    </WSnackbarContext.Provider>
  );
}
